export interface Course {
  id?: number;
  name?: string;
  type?: string;
  duration?: string;
}

export interface CourseState {
  availableCourses: Course[];
  isJacadCourse: boolean;
}

const courseState: CourseState = {
  availableCourses: [],
  isJacadCourse: false,
};

export default courseState;
